export const ROOM_GROUP_NAME = "room";
export const WALLS_GROUP_NAME = "walls";

export const DEFAULT_CEILING_COLOR = "#ffffff";
export const TILE_SIZE = 8000;
export const STEP_VALUE = 50; //Шаг между перфорацией
